import { createFileRoute, redirect } from "@tanstack/react-router";
import { citySlug } from "@/utils/citySlug";

// Canonical city URL is /masini-de-vanzare-{city}; 301 on the server so
// crawlers never see the empty legacy page. Diacritics/case are normalized
// to the same slug; the city itself is never guessed or substituted.
export const Route = createFileRoute("/orase/$city/")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/masini-de-vanzare-${citySlug(params.city)}`, statusCode: 301 });
  },
});
